export default __webpack_public_path__ + "static/media/report_navicon-light.292b2952.svg";